
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

//draft-Editor
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from "html-to-draftjs";

//context 
import { usePagesState, setPrivacyPolicy, GetPrivacyPolicy } from "../../context/PagesContext";
import { Button, Box } from "@material-ui/core";

//global css
import "../../static/css/global.css";

//Privacy Policy Page
const AddEditPrivacyPolicy = () => {
  const context = usePagesState();

  const [editorstate, seteditorstate] = useState(() => EditorState.createEmpty())
  const [Convertedcontent, setConvertedcontent] = useState(null);
  const [disable, setdisable] = useState(true);

  useEffect(() => {
    GetPrivacyPolicy(context.setprivacyData)
  }, []);


  useEffect(() => {
    if (context.privacyData.privacyData.data && context.privacyData.privacyData.data.content) {


      let blocksFromHtml = htmlToDraft(context.privacyData.privacyData.data.content);
      let { contentBlocks, entityMap } = blocksFromHtml;
      let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      let editorState = EditorState.createWithContent(contentState);
      seteditorstate(editorState);
    }
  }, [context.privacyData.privacyData.data])

  const handleEditorChange = (state) => {
    seteditorstate(state);
    convertContentToHTML();
    setdisable(false)

  }

  //convert draft to html 
  const convertContentToHTML = () => {
    let currentContentAsHTML = draftToHtml(convertToRaw(editorstate.getCurrentContent()))
    setConvertedcontent(currentContentAsHTML);
  }

  const HandleSubmit = () => {
    const reqData = {
      id: 3,
      content: Convertedcontent,
    }
    setPrivacyPolicy(context.setprivacypolicy, reqData);
  }

  return (<>
    <div className="RichText">
      <Editor
        editorState={editorstate}
        onEditorStateChange={handleEditorChange}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class" />
    </div>

    <div className="submit_button">
      <Box component="span" m={1}
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end">

        <Button variant="contained" color="primary" onClick={HandleSubmit} disabled={disable} > Update </Button>

      </Box>
    </div>
  </>
  );
}
export default withRouter(AddEditPrivacyPolicy);